export default __webpack_public_path__ + "static/media/twitterVector.10113403.svg";